module.exports = __webpack_public_path__ + "static/media/_MIC2735.thumbnail.2278bb2d.png";